<script>
//import Vue from 'vue'
   // import Swal from 'sweetalert2'
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Trucks",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Trucks",
            items: [
               {
                  text: "Trucks",
                  active: true,
               },                   
            ],
            trucks: [], 
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {}, 
            active_page_url: null,
            from: null,
            to: null,
            total: null,
            pagination: {},

            truck_status: {
               id: "",
               status: "",
            },
         };
      },
      created() {
         this.fetchTrucks();
      },
      mounted() {
      },
      methods: {
         fetchTrucks(page_url = null) {
            //Vue.swal("Hello");
            // this.$swal('Test!', 'Hello test message','success');

            let url = "api/admin/trucks?&keyword=" + this.keyword + "&limit=" + this.listing_length+ "&status=" + this.status;         
            this.getToken();
            page_url = page_url || url;
             
            this.active_page_url = page_url;
            this.loading = true;


            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if(res.status == 200) {

               var responseData = res.data.data;
               console.log(responseData);
               this.trucks = responseData.trucks.data; 
              //console.log(stocklogs);
              this.pagination = responseData.trucks.links;
               this.from = responseData.trucks.from;
               this.to = responseData.trucks.to;
               this.total = responseData.trucks.total;
               }
                     
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         getToken() {
         if (localStorage.getItem('sigofuel_admin')) {
            var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
            if(sigofuel_admin.token) {
               this.token = sigofuel_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
      activateTruck(truck) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this truck?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.truck_status.id = truck.id;
                  this.truck_status.status = 1;
                  this.updateTruckStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateTruck(truck) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this truck?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.truck_status.id = truck.id;
                  this.truck_status.status = 2;
                  this.updateTruckStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateTruckStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/truck/status?id=" + this.truck_status.id + "&status=" + this.truck_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchTrucks(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'trucks.add' }" class="btn btn-primary float-end">Add Truck</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchTrucks()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchTrucks()"/>
                           </label>
                        </div> 

                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchTrucks()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>                         
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Truck No.</th>
                              <th>Manufacturer</th>
                              <th>Manufactured Year</th>
                              <th>Model</th>
                              <th>Colour</th>
                              <th>Fuel Station</th>
                              <th>Status</th>
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(trucks.length)">
                           <tr v-for="(truck) in trucks" :key="truck.id">
                              <td>{{truck.truck_no}}</td>
                              <td>{{truck.manufacturer}}</td>                 
                              <td>{{truck.manufactured_year}}</td>
                              <td>{{truck.model}}</td>
                              <td>{{truck.color}}</td>
                              <td>{{truck.fuel_station_name_en}}</td>

                              <td>
                                 <span  class="badge rounded-pill bg-success" v-if="truck.status==1">Active</span>
                                 <span class="badge rounded-pill bg-danger" v-if="truck.status==2">Blocked</span>                              </td>
                              <td>{{truck.converted_created_at | formatDateTime }}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'trucks.details' , params: {id: truck.id}}" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <router-link :to="{ name: 'trucks.edit', params: {id: truck.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link>

                                 <router-link :to="{ name: 'trucks.fuels', params: {id: truck.id,fuel_station_id: truck.fuel_station_id}  }" class="btn btn-primary me-2 mb-2 btn-sm">Fuels</router-link>
               
                                 <b-button v-if="truck.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateTruck(truck)">Unpublish</b-button>

                                    <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateTruck(truck)">Publish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No trucks found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                 <!----pagination starts ---> 
                 <caption v-if="Boolean(trucks.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTrucks(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
